import { InvalidFieldError } from '../../validation/errors/invalid-field-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'
import { type ValidatePhoneAdapter } from '../../validation/protocols/validate-phone-adapter'

export class PhoneValidation implements FieldValidation {
  private readonly validatePhoneAdapter: ValidatePhoneAdapter
  readonly field: string

  constructor (field: string, validatePhoneAdapter: ValidatePhoneAdapter) {
    this.field = field
    this.validatePhoneAdapter = validatePhoneAdapter
  }

  validate (value: string): Error | null {
    const isValid = this.validatePhoneAdapter.validate(value)
    return isValid ? null : new InvalidFieldError('telefone')
  }
}
